import { CartExpired } from "@vue/common/errors/cartExpired";

window.onunhandledrejection = event => {
  // Keep CartExpired out of sentry error logs.
  if(event.reason instanceof CartExpired) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
};
